import * as React from "react";
function SvgUserDashboard(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        x={21}
        y={19}
        width={10}
        height={10}
        rx={0.5}
        ry={0.5}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M24 23h8M25 20v8"
      />
      <circle
        cx={12}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M7.11 29H1a11 11 0 0118-8.48"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserDashboard);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
